:host {
  @media print {
    display: none;
  }

  // ::slotted([slot="logo"]) {
  //   height: 38px;
  // }
}

.stzh-pagebottom {
  &__wrapper {
    display: grid;
  }

  &__left {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    row-gap: space('xsmall');

    @include mq($from: small) {
      flex-direction: row;
    }
  }

  &__share-title {
    @include fontCurve('caption');
    margin-bottom: space('small');
  }

  &__sticky-actions {
    margin-left: auto;
    margin-top: space('medium');

    --stzh-button-white-space: nowrap;

    @include mq($from: small) {
      margin-top: 0;
    }
  }

  &__print,
  &__share-wrapper {
    flex-shrink: 0;
  }

  &__share-wrapper {
    margin-left: -10px;

    @include mq($from: medium) {
      margin-left: 0;
    }
  }

  &__print {
    @include mq($from: small) {
      margin-right: space('xxlarge');
    }

    @include mq($from: medium) {
      @include spaceCurve('margin-right', 'big');
    }
  }

  // &__logo {
  //   @include mq($from: small) {
  //     margin-left: auto;
  //   }
  // }

  // &__logo-link {
  //   &:not(:empty) {
  //     display: block;
  //     margin-top: space('xlarge');

  //     @include mq($from: small) {
  //       margin-top: 0;
  //       margin-left: space('xlarge');
  //     }
  //   }
  // }

  &:has(#{&}__sticky-actions:not(:empty)) &__wrapper {
    grid-template-columns: auto;

    @include mq($from: small) {
      grid-template-columns: minmax(0, 1fr) calc(110px + 44px + #{space('small')} + #{space('medium')});
    }
  }
}
